import { Link } from "react-router-dom";
import Logo from "./brand/Logo";
import NewsletterForm from "./NewsletterForm";
import { openConsentPreferences } from "../lib/consent";
import { LEGAL } from "../lib/legalConfig";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-ink text-white">
      <div className="page-container pt-24 pb-12">
        <div className="grid grid-cols-12 gap-y-16 gap-x-8">
          <div className="col-span-12 md:col-span-6">
            <Logo className="text-white" />
            <p className="label-eyebrow text-white/60 mt-3">Editoriale beauty</p>
            <h2 className="serif italic text-6xl md:text-8xl leading-[0.9] mt-6">
              Tool giusti.<br />Routine più corta.
            </h2>
            <p className="mt-8 max-w-md text-white/70 leading-relaxed">
              Selezioni oneste di beauty tools e organizer vanity.
              Nessun claim medico, nessuna promessa impossibile — solo scelte durevoli
              per una routine più intelligente.
            </p>
          </div>

          <div className="col-span-6 md:col-span-2">
            <p className="label-eyebrow text-white/60 mb-6">Naviga</p>
            <ul className="space-y-3">
              <li><Link to="/" className="link-underline">Home</Link></li>
              <li><Link to="/guide" className="link-underline">Guide</Link></li>
              <li><Link to="/categorie" className="link-underline">Categorie</Link></li>
              <li><Link to="/liste" className="link-underline">Liste</Link></li>
              <li><Link to="/about" className="link-underline">About</Link></li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-2">
            <p className="label-eyebrow text-white/60 mb-6">Legale</p>
            <ul className="space-y-3">
              <li><Link to="/privacy" className="link-underline">Privacy</Link></li>
              <li><Link to="/cookie" className="link-underline">Cookie</Link></li>
              <li><Link to="/termini" className="link-underline">Termini</Link></li>
              <li><Link to="/note-legali" className="link-underline">Note legali</Link></li>
              <li><Link to="/disclosure" className="link-underline">Trasparenza</Link></li>
              <li><Link to="/policy" className="link-underline">Niente claim medici</Link></li>
              <li>
                <button
                  type="button"
                  onClick={() => openConsentPreferences()}
                  className="link-underline bg-transparent border-0 p-0 cursor-pointer text-inherit text-left"
                  data-testid="footer-cookie-preferences"
                >
                  Preferenze cookie
                </button>
              </li>
              <li><Link to="/about#contatti" className="link-underline">Contatti</Link></li>
            </ul>
          </div>

          <div className="col-span-12 md:col-span-2">
            <p className="label-eyebrow text-white/60 mb-6">Scrivici</p>
            <a
              href={`mailto:${LEGAL.contactEmail}`}
              data-testid="footer-email"
              className="link-underline text-white/90"
            >
              {LEGAL.contactEmail}
            </a>
            <p className="mt-4 text-xs text-white/60 leading-relaxed">
              Per come trattiamo i messaggi, vedi l&apos;
              <Link to="/privacy" className="link-underline text-white/70">
                Informativa privacy
              </Link>
              .
            </p>
            <p className="mt-4 text-xs text-white/60 leading-relaxed">
              Redazione digitale. Rispondiamo entro 48 ore lavorative.
            </p>
            <div className="mt-10">
              <NewsletterForm source="footer" />
            </div>
          </div>
        </div>

        <div className="hairline mt-20 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p
            data-testid="product-disclosure"
            className="text-xs text-white/60 leading-relaxed max-w-2xl"
          >
            <span className="label-eyebrow text-white/80 mr-3">Disclosure</span>
            Alcuni link sono commerciali: potremmo ricevere una commissione o vendere direttamente.
            Il prezzo per te non cambia.
          </p>
          <p className="text-xs text-white/60">
            © {year} Glowkit — Tutti i diritti riservati
          </p>
        </div>
      </div>
    </footer>
  );
}
